// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__33rBz","content":"styles_content__1X2kc","selectAll":"styles_selectAll__21Xzn"};